import { useEffect } from "react";
import { useOptCreatorInFeatureMutation } from "../../redux/reduxAPI";
import { CreatorConfig, CreatorDashboardSource } from "../../types/creator";
import { EFE_UTM_SOURCE } from "../../utils/constants";

const TEST_ENGAGE_PREFIX = "TEST_ENGAGE__";

type Props = {
  creatorConfig?: CreatorConfig;
  dashboardSource?: CreatorDashboardSource;
  onOptedIn?: () => void;
};

/**
 * Auto-enrols creators who arrived via the EFE campaign into the TEST_ENGAGE
 * experiment, unless they already carry an assignment.
 */
const EfeExperimentOptIn = ({
  creatorConfig,
  dashboardSource,
  onOptedIn,
}: Props) => {
  const [triggerOptCreatorInFeature] = useOptCreatorInFeatureMutation();

  useEffect(() => {
    if (!creatorConfig?.creator_id) return;
    if (dashboardSource?.utm_source !== EFE_UTM_SOURCE) return;

    const alreadyAssigned = Object.keys(
      creatorConfig?.authorizations || {}
    ).some((key) => key.startsWith(TEST_ENGAGE_PREFIX));
    if (alreadyAssigned) return;

    triggerOptCreatorInFeature({
      feature_name: "TEST_ENGAGE",
      variant_name: "EXPERIMENT",
    }).then(() => onOptedIn?.());
  }, [creatorConfig, dashboardSource]);

  return null;
};

export default EfeExperimentOptIn;
